/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/asana" */ '@atlassian/logo-third-party/asana'
		).then((m) => m.AsanaIcon),
	{ moduleId: '@atlassian/logo-third-party/asana' },
);

const LazyForgeUnitoAsanaDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-dev" */ './utils').then(
			(m) => m.ForgeUnitoAsanaDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/icon' },
);

const LazyForgeUnitoAsanaDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoAsanaDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoAsanaDevIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoAsanaDevIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgeUnitoAsanaDevSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgeUnitoAsanaDevSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
